<template>
  <div>
    <div class="row">
      <div class="col-lg-6">
        <div class="process-graphic w-100 h-100">
          <div class="windward-logo w-100 h-100 d-flex align-items-center justify-content-center">
            <ul class="circle-container">
              <li id="process-0" class="in"><span>POSITION</span></li>
              <li class="arrow"><i class="fas fa-triangle"></i></li> 
              <li id="process-1" class="in"><span>CREATE</span></li>
              <li class="arrow"><i class="fas fa-triangle"></i></li>
              <li id="process-2" class="in"><span>DELIVER</span></li>
              <li class="arrow"><i class="fas fa-triangle"></i></li>
              <li id="process-3" class="in"><span>EVOLVE</span></li>
              <li class="arrow"><i class="fas fa-triangle"></i></li>
            </ul>
            <div class="circle-0"></div>
            <div class="circle-1"></div>
            <div class="circle-2"></div>
            <div class="circle-3"></div>
            <div class="circle-4"></div>
            <div class="circle-5"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <div class="col-lg-6 process-item" v-for="(item, i) in process_items" :key="i" @mouseenter="highlight(i)" @mouseleave="unhighlight(i)" ref="el">
            <div class="process-item-content mt-3 pt-3 pb-2 mt-md-5 pt-md-5 pb-md-4">
              <h6 class="text-white font-bold pb-1 pb-md-4" v-html="item.process_title"></h6>
              <div class="process-content text-white fz-20" v-html="item.process_content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {},
  mounted() {
    const process_data = document.querySelector("#processData");
    this.process_items = JSON.parse(process_data.dataset.items);
  },
  methods: {
    highlight(i) {
      const process_description = this.$refs.el[i];
      process_description.classList.add("active");
      const title = process_description.querySelector("h6");
      const process_item = document.querySelector("#process-0");
      process_item.classList.add("active");
      this.reorderItems(title.textContent)
    },
    unhighlight(i) {
      const process_description = this.$refs.el[i];
      process_description.classList.remove("active");
      const process_item = document.querySelector("#process-0");
      process_item.classList.remove("active");
    },
    reorderItems(starting_with="POSITION"){
      let titles = this.item_titles;
      var found = titles.findIndex(function(element) {
        return element == starting_with;
      });
      titles = titles.slice(found,found + 4);

      for (let i = 0; i < 4; i++) {
        const process_li = document.querySelector("#process-" + i);
        process_li.classList.remove("in");
        setTimeout(function(){
          process_li.innerHTML = "<span>" + titles[i] + "</span>";
          setTimeout(function(){
            process_li.classList.add("in");
          }, 100);
        }, i*300);
      }
    }
  },
  data() {
    return {
      process_items: "",
      item_titles: ["POSITION", "CREATE", "DELIVER", "EVOLVE", "POSITION", "CREATE", "DELIVER"]
    };
  }
};
</script>
